import { FileTextOutlined } from "@ant-design/icons";
import moment from "moment";

export const AdditionalInformation = (props) => {
  const { selectedBooking } = props;
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <FileTextOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
        <h3 style={{ margin: 0, color: "#333" }}>Additional Information</h3>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "10px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Special Request:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.specialRequest || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Notes:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.notes || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Created At:</strong>
          <span style={{ color: "#555" }}>
            {selectedBooking.createdAt
              ? moment(selectedBooking.createdAt).format("DD-MM-YYYY HH:mm")
              : "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Updated At:</strong>
          <span style={{ color: "#555" }}>
            {selectedBooking.updatedAt
              ? moment(selectedBooking.updatedAt).format("DD-MM-YYYY HH:mm")
              : "N/A"}
          </span>
        </p>
      </div>
      {selectedBooking.addonServices &&
        selectedBooking.addonServices.length > 0 && (
          <div style={{ marginTop: "15px" }}>
            <h4 style={{ margin: 0, color: "#1890ff" }}>Addon Services</h4>
            {selectedBooking.addonServices.map((service, index) => (
              <div
                key={service._id || index}
                style={{
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                }}
              >
                <p style={{ margin: 0 }}>
                  <strong>Service {index + 1}:</strong>{" "}
                  <span style={{ color: "#555" }}>
                    {service.serviceName || "N/A"}
                  </span>
                </p>
                <p style={{ margin: 0 }}>
                  <strong>Price:</strong>{" "}
                  <span style={{ color: "#555" }}>
                    {service.servicePrice || "N/A"}
                  </span>
                </p>
                <p style={{ margin: 0 }}>
                  <strong>Description:</strong>{" "}
                  <span style={{ color: "#555" }}>
                    {service.serviceDescription || "N/A"}
                  </span>
                </p>
              </div>
            ))}
          </div>
        )}
    </div>
  );
};
